/**
 * 역할 정의 — 명세서 §3.1 / §3.2
 */
export const ROLES = {
    ADMIN: 'ADMIN',
    DIRECTOR: 'DIRECTOR',
    TEACHER: 'TEACHER',
    PARENT: 'PARENT',
    DRIVER: 'DRIVER',
};
export const ROLE_LABELS = {
    ADMIN: '시스템 관리자',
    DIRECTOR: '원장',
    TEACHER: '보육교사',
    PARENT: '학부모',
    DRIVER: '차량 기사',
};
/** 시설 내부 교직원 역할 (원아 데이터 전반 접근) */
export const STAFF_ROLES = [ROLES.DIRECTOR, ROLES.TEACHER];
/** 시설 운영 권한 (설정·승인·통계) */
export const FACILITY_MANAGER_ROLES = [ROLES.DIRECTOR];
export function isStaff(role) {
    return STAFF_ROLES.includes(role);
}
export const MEMBER_STATUS = {
    PENDING: 'PENDING',
    ACTIVE: 'ACTIVE',
    SUSPENDED: 'SUSPENDED',
    LEFT: 'LEFT',
};
/** 보호자 ↔ 원아 관계 유형 — §4 가족 그래프 */
export const GUARDIAN_RELATIONS = {
    MOTHER: 'MOTHER',
    FATHER: 'FATHER',
    GRANDPARENT: 'GRANDPARENT',
    OTHER: 'OTHER',
};
export const GUARDIAN_RELATION_LABELS = {
    MOTHER: '어머니',
    FATHER: '아버지',
    GRANDPARENT: '조부모',
    OTHER: '기타',
};
//# sourceMappingURL=roles.js.map